var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrgListEmployee',{attrs:{"orgId":_vm.orgId,"title":_vm.$t('lbl_list_of_staff')}})
}
var staticRenderFns = []

export { render, staticRenderFns }